import React from "react";

const DesktopIcon = ({ icon, label, selected, isMobile, onSelect, onOpen }) => {
  const handleClick = () => {
    if (isMobile) {
      onOpen();
      return;
    }
    if (selected) {
      onOpen();
    } else {
      onSelect();
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      onDoubleClick={onOpen}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onOpen();
        }
      }}
      className="win-focus-dotted flex w-20 flex-col items-center gap-1 rounded-sm px-1 py-2 text-center"
      style={{
        background: selected ? "rgba(0,0,128,0.55)" : "transparent",
        outline: selected ? "1px dotted #ffffff" : "none",
        outlineOffset: "-3px",
      }}
    >
      <span className="text-[34px] leading-none drop-shadow-[2px_2px_0_rgba(0,0,0,0.6)]" aria-hidden="true">
        {icon}
      </span>
      <span
        className="text-xs font-bold leading-tight text-white"
        style={{ textShadow: "1px 1px 1px #000, -1px -1px 1px #000, 1px -1px 1px #000, -1px 1px 1px #000" }}
      >
        {label}
      </span>
    </button>
  );
};

export default DesktopIcon;
